// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"56":"c28361db","344":"f451088f","465":"c28361db","673":"16db67d5","763":"27b7eab9","783":"3a4b48b2","843":"528232d5"}[chunkId] + ".css";
};